import React, { useState,useEffect } from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import '../src/styles/About.css';
import lotus from '../src/images/lotus.png';
import { useRive } from "@rive-app/react-canvas";
import Kanwal from '../src/images/kanwal.jpeg';

function RiveAnimation() {
  const { RiveComponent: RivePlayer } = useRive({
    src: "/maze.riv",
    autoplay: true,
  });

  return (
    <div className='aboutMazeDiv'>
      <RivePlayer />
    </div>
  );
}

const About = () => {
  const [scrolled, setScrolled] = useState(false);
  
  useEffect(() => {
    const handleScroll = () => {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  
      const maze_bck = document.querySelector(".maze_bck");
      if (maze_bck) {
        maze_bck.style.top = `-${scrollTop}px`;
      }
  
      if (scrollTop > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
  
    window.addEventListener("scroll", handleScroll);
    handleScroll();
  
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className='aboutBody'>
      <Header scrolled={scrolled}/>
      <div className='maze_bck position-absolute d-flex flex-column justify-content-center align-items-center gap-3'>
        <div className='aboutMoto'>KWA Where the Pathway to Justice Begins</div>
        <div className='d-flex justify-content-center align-items-center'>
          <div className='h-100 d-flex align-items-end p-1'><div style={{backgroundColor:'black',color:'white',borderRadius:'16px'}} className='p-1'>KWA</div></div>
        <RiveAnimation className="square"/>
          <div className='h-100 d-flex p-1'><div className='p-1' style={{backgroundColor:'black',color:'white',borderRadius:'16px',height:'fit-content'}}>Justice</div></div>
        </div>
      </div>
      <div className='secondbck d-flex justify-content-center align-items-center'>
        <div className='d-flex justify-content-center align-items-center' style={{width: '73%'}}>
          <img src={lotus} alt='fd' className='lotus'></img>
          <div className='d-flex gap-5 smallScreenAdjust'>
            <div className='d-flex flex-column gap-2'>
              <img alt='' className='kanwalPic' src={Kanwal} style={{zIndex:'1'}}></img>
              <div className='d-flex flex-column justify-content-center align-items-center '>
                <h2 style={{fontSize: 'clamp(15px, 2vw, 20px)'}}>Adv. Kanwal walia</h2>
                <h2 className='text-center' style={{fontSize: 'clamp(15px, 2vw, 20px)'}}>Punjab & Haryana High Court and Supreme Court</h2>
                <h2 style={{fontSize: 'clamp(15px, 2vw, 20px)'}}>Founder of KWA</h2>
              </div>
            </div>
            <div className='gap-4'>
              <p style={{fontSize: 'clamp(15px, 2vw, 20px)'}}>
                B.Com from GNDU<br />
                LLB from Panjab University,Chandigarh<br />
                LLM from Kurukshetra University<br />
                Currently pursuing PHD from CTU, Ludhiana
              </p>
              <p style={{fontSize: 'clamp(15px, 2vw, 20px)'}}>
                Has represented various Government Departments and Institutions, Private Institutions and Banks and Corporations in their matters before all forums from Quasi Judicial Tribunals/Forums to the Apex Court.
              </p>
              <p style={{fontSize: 'clamp(15px, 2vw, 20px)'}}>
                Currently practicing as a lawyer at High Court of Punjab & Haryana and Supreme Court of India with appearance in District & Session Courts of Tricity and other cities of Punjab. Having good knowledge of Civil as well as Criminal litigation and Drafting of Agreements and other legal Documents, Arbitration for Government bodies as well as for private individuals. Appearance in Consumer Protection State Consumer Disputes Redressal Commissions, NCLT, DRT and various Ministries situated at Delhi.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default About;
